/* eslint-disable max-len */
import vik from 'pages/loans/[coin]/assets/avatars/vik-cake.jpg'
import reddit from 'images/icon-reddit.svg'
import { imageSizes } from 'pages/loans/[coin]/assets/page-data/types'
import titan from 'pages/loans/[coin]/assets/avatars/titan.png'
import trustpilot from 'images/logo-trustpilot.svg'
import valerios from 'pages/loans/[coin]/assets/avatars/valerios-baglaridis.jpg'
import twitter from 'images/icon-twitter.svg'

export const commonSlidesData = (prefix: string) => ({
  slides: [
    {
      id: 1,
      link:
        'https://www.reddit.com/r/Monero/comments/ooqc4p/borrowing_xmr_at_coinrabbit/h6z923w/?utm_source=reddit&utm_medium=web2x&context=3',
      author: {
        name: 'Vik Sharma',
        position: 'Cake Wallet CEO',
        avatar: vik,
        avatarAlt: `${prefix} review 1`,
      },
      image: reddit,
      imageWidth: imageSizes.reddit,
      imageAlt: `${prefix} review 1`,
      title: <>Reliable, safe and fast Crypto loans</>,
      text: (
        <>
          I&apos;ve used CoinRabbit multiple times and found their service to be reliable, safe, and fast. The customer
          service has been spectacular as well. I would recommend this to anyone who wants a loan against their crypto.
        </>
      ),
    },
    {
      id: 2,
      link: 'https://www.trustpilot.com/reviews/60ac6e23f9f4870a94ac0fca',
      author: {
        name: 'Titan',
        avatar: titan,
        avatarAlt: `${prefix} review 2`,
      },
      image: trustpilot,
      imageWidth: imageSizes.trustpilot,
      imageAlt: `${prefix} review 2`,
      title: <>CoinRabbit has fully earned my trust</>,
      text: (
        <>
          Coinrabbit has fully earned my trust and I will use them for life! Quick response with customer service and
          good people. Love Coinrabbit!!
        </>
      ),
    },
    {
      id: 3,
      link: 'https://twitter.com/walerikus/status/1420427814000644099?s=21',
      author: {
        name: 'Valerios Baglaridis',
        position: 'DGB Influencer',
        avatar: valerios,
        avatarAlt: `${prefix} review 3`,
      },
      image: twitter,
      imageWidth: imageSizes.twitter,
      imageAlt: `${prefix} review 3`,
      title: <>By far the best user experience provided by CoinRabbit</>,
      text: (
        <>
          CoinRabbit provides by far the best user experience, and I have tried nexo finances, celsius and various
          ethereum based defi protocols like MakerDAO and compound finance.
        </>
      ),
    },
  ],
})

export const commonLearnMoreData = (prefix: string) => ({
  blogCards: [
    {
      link: 'https://coinrabbit.io/blog/what-is-crypto-lending-and-how-does-it-work/',
      image:
        'https://cdn.shortpixel.ai/client/q_lossless,ret_img,w_1185/https://coinrabbit.io/blog/wp-content/uploads/2021/07/photo_2021-07-23_20-28-31.jpg',
      imageAlt: `${prefix} review 5`,
    },
    {
      link: 'https://coinrabbit.io/blog/how-crypto-assets-are-secured/',
      image: 'https://coinrabbit.io/blog/wp-content/uploads/2021/08/integration-52CR_LQ.png',
      imageAlt: `${prefix} review 6`,
    },
    {
      link: 'https://coinrabbit.io/blog/guide-to-short-selling-with-coinrabbit-bear-market-loans/',
      image: 'https://coinrabbit.io/blog/wp-content/uploads/2021/06/Bear-loans.png',
      imageAlt: `${prefix} review 7`,
    },
  ],
})

export const blogCards = {
  cryptoCrash: {
    link: 'https://coinrabbit.io/blog/cryptocrash/',
    image:
      'https://sp-ao.shortpixel.ai/client/to_webp,q_lossless,ret_img,w_3200/https://coinrabbit.io/blog/wp-content/uploads/2022/05/0.-Title.png',
    imageAlt: 'Surviving the Crypto Crash: How to take advantage of the crisis',
  },
  borrowLikePro: {
    link: 'https://coinrabbit.io/blog/borrow-like-a-pro/',
    image:
      'https://sp-ao.shortpixel.ai/client/to_webp,q_lossless,ret_img,w_3200/https://coinrabbit.io/blog/wp-content/uploads/2022/06/Ltt.png',
    imageAlt: 'Crypto Loans: Tips and Tricks',
  },
  howCryptoAssetsSecured: {
    link: 'https://coinrabbit.io/blog/how-crypto-assets-are-secured/',
    image: 'https://coinrabbit.io/blog/wp-content/uploads/2021/08/integration-52CR_LQ.png',
    imageAlt: 'How Crypto Assets Are Secured on CoinRabbit',
  },
  whatTypesOfCryptoLoansAreThereAndHowCanIProfitFromIt: {
    link: 'https://coinrabbit.io/blog/what-types-of-crypto-loans-are-there-and-how-can-i-profit-from-it/',
    image: 'https://coinrabbit.io/blog/wp-content/uploads/2021/12/1.png',
    imageAlt: 'What types of crypto loans are there and how can I profit from it?',
  },
}
